import { Stack } from "@mui/material"
import { useEffect, useState } from "react"
import { getTransactions } from "../../api"
import dayjs from "dayjs"
import ExpenseCard from "../cards/ExpenseCard"
import IncomeCard from "../cards/IncomeCard"

const ProgramFeePayments = () => {
  const endTime = dayjs()
  const startTime = endTime.subtract(7, "year").startOf("day")
  const [data, setData] = useState([])

  const fetchData = () => {
    getTransactions({
      from: startTime.toISOString(),
      to: endTime.toISOString(),
    })
      .then((res) => {
        setData(
          [...res.data.expenses, ...res.data.incomes].sort((a, b) =>
            dayjs(a.creationTimestamp).isAfter(dayjs(b.creationTimestamp))
              ? -1
              : 1
          )
        )
      })
      .catch((err) => console.log(err))
  }

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Stack>
      {data.map((d, i) =>
        "expenseHeadId" in d ? (
          <ExpenseCard key={i} data={d} />
        ) : (
          <IncomeCard key={i} data={d} />
        )
      )}
    </Stack>
  )
}

export default ProgramFeePayments
